import { apiFetch } from '@/lib/api-client';

// Admin-only READ-ONLY view of the DMP address_mapping_table (operator submissions). Pure SELECT — the
// API exposes no edit endpoint for this view. Mirrors the route DTO in routes/internal/admin-mapping.ts.

export interface MappingTableRow {
  jvid: number;
  operatorId: number;
  operatorLabel: string;
  isDemo: boolean;
  streetName: string | null;
  houseNumber: string | null;
  houseNumberExtension: string | null;
  busNumber: string | null;
  appartmentNumber: string | null;
  postalCode: string | null;
  municipality: string | null;
  city: string | null;
  dwellingUnitType: string | null;
  scopelist: string | null;
  modifiedBy: string | null;
  createdAt: string | null;
  updatedAt: string | null;
}

/** All address_mapping_table rows (read-only). Admin-only (SYSTEM_ADMIN). */
export function fetchMappingTable(): Promise<{ data: MappingTableRow[] }> {
  return apiFetch<{ data: MappingTableRow[] }>('/admin/mapping-table');
}
